module.exports = __webpack_public_path__ + "static/media/nexo-earn-rates.1.221b9088.jpg";